<div class="basket-container">
  <div class="basket-header" id="basket-header" *ngIf="!displayChargesOnly">
    @if (displayTitle) {
      <div class="basket-header-row">
        <span class="cart-title">
          <mat-icon class="cart-icon">shopping_cart</mat-icon>
          Cart ({{ currentBasketCount }} {{ currentBasketCount <= 1 ? 'item' : 'items'}})
        </span>
        <mat-icon *ngIf="showBasketToggle" class="basket-close-icon" (click)="closeBasket()">close</mat-icon>
      </div>
    }

    <div class="occasion-options"
         id="occasionsToggleContainer"
         *ngIf="supportsBothOccasions && !disableBasketEditing && currentBasket && showOccasionsToggle && currentBasket.Occasion !== orderOccasion.DineIn">
      <mat-button-toggle-group class="basket-header-toggle-group"
                              [value]="currentBasket.Occasion"
                              appearance="legacy"
                              [hideSingleSelectionIndicator]="true"
                              #occasionToggle="matButtonToggleGroup"
                              (change)="toggleBasketOccasionChange($event)">
        <mat-button-toggle class="occasion-option" [ngClass]="{'active': currentBasket.Occasion === 'Delivery'}"
                          value="Delivery"
                          aria-label="Text align left"
                          [ngClass]="{'basket-header-toggle-disabled': !postCodeWithinDelivery}"
                          [disabled]="!postCodeWithinDelivery">
          <div class="occasion-option-title">Delivery</div>
          <div class="occasion-option-time" *ngIf="fastestDeliveryTime">Estimated: {{fastestDeliveryTime}}mins</div>
        </mat-button-toggle>
        <mat-button-toggle class="occasion-option" [ngClass]="{'active': currentBasket.Occasion === 'Collection'}"
                          value="Collection"
                          aria-label="Text align center">
          <div class="occasion-option-title">Collection</div>
          <div class="occasion-option-time" *ngIf="fastestCollectionTime">Estimated: {{fastestCollectionTime}}mins</div>
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </div>

  <div class="basket-body" id="basket-body" *ngIf="!displayChargesOnly">
    <div class="no-products" *ngIf="currentBasket?.Items?.length === 0 && currentBasket?.Deals?.length === 0">
      <span>Your basket is empty</span>
    </div>

    @for (item of dealItems; track $index) {
      <div class="basket-item" [ngClass]="{'basket-item-hasIssues': item.hasIssues}">
        <app-basket-deal-item [item]="item"
                              [basketIsModifiable]="basketIsModifiable"
                              [currentBasket]="currentBasket"
                              style="width: 100%"></app-basket-deal-item>
      </div>
    }

    @for (item of productItems; track $index) {
      <div class="basket-item" [ngClass]="{'basket-item-hasIssues': item.issues.length > 0}">
        <app-basket-product-item [item]="item"
                                 [basketIsModifiable]="basketIsModifiable"
                                 style="width: 100%"></app-basket-product-item>
      </div>
    }
  </div>

  @if (!isThankYouPage) {
    <div class="w-full flex flex-center">
      <span class="return-to-home" (click)="closeBasket()">RETURN TO MENU</span>
    </div>
  }

  <div style="flex-shrink: 0;">
    <ng-container *ngIf="!isThankYouPage && user">
      <app-basket-loyalty [basket]="currentBasket"
                          [orderComplete]="orderComplete"
                          class="basket-loyalty"
                          [basketTotal]="basketTotal"
                          [userId]="user?.Id"
                          [usersLoyaltyPoints]="usersLoyaltyPoints"
                          [earnablePointsForCurrentBasket]="earnablePointsForCurrentBasket"
                          [currentSite]="currentSite"
                          *ngIf="!tenant?.SuppressLoyalty && loyaltyDiscount <= 0"></app-basket-loyalty>

      <app-basket-voucher [basket]="currentBasket"
                          [orderComplete]="orderComplete"
                          [disableVoucherEditing]="disableVoucherEditing"
                          [user]="user"
                          *ngIf="!tenant?.SuppressVouchers && currentBasket"
                          class="basket-voucher"></app-basket-voucher>
    </ng-container>

    <div class="flex-column"
         *ngIf="
          currentBasket?.LoyaltyPointsValue &&
          !orderComplete &&
          showEarnableLoyaltyPoints() &&
          !user &&
          !isThankYouPage"
        style="font-size: 13px; text-align: center;">
      <span>You could earn {{ earnablePointsForCurrentBasket }} loyalty points when completing this order.</span>
      <span>You must be logged in to earn or redeem loyalty points.</span>
    </div>

    <div class="charges-section">
      <app-basket-charges [basket]="currentBasket"
                        [orderComplete]="orderComplete"
                        [basketTotal]="basketTotal"
                        [loyaltyDiscount]="loyaltyDiscount"></app-basket-charges>

      <ng-container *ngIf="showCheckout && (currentBasket?.Items.length > 0 || currentBasket?.Deals.length > 0)">
        <button class="checkout-button"
                [ngClass]="{'disabled': shouldDisableCheckout()}"
                (click)="goToCheckout()"
                [disabled]="shouldDisableCheckout()">
          <span>{{ user?.Id ? 'Proceed' : 'Sign In' }} To Checkout</span>
          <span class="checkout-price">£{{basketTotal | StringToMoneyFilter}}</span>
        </button>
      </ng-container>
    </div>
  </div>
</div>
